// extracted by mini-css-extract-plugin
export default {"helpIconNoLabel":"helpIconNoLabel---CJpmu","helpIcon":"helpIcon---hK88G"};